Router = App.loadClass 'core::Router'
Factory = App.loadClass 'core::Factory'

class exports.RatingsRouter extends Router

    prefix: 'Ratings'
    module_name: 'RatingsRouter'

    register: ->
        @module = angular.module @module_name, ['ui.router', 'ui.bootstrap']

        # this is used by all the services
        @factory 'ratingsFactory', ->
            return new Factory('portal::Angular/Ratings/Models')


        #################
        # Sidebar Stuff #
        #################

        # sidebar service
        @service 'portal::Angular/Ratings/Sidebar/SidebarService', ['$http', '$rootScope', 'ratingsFactory']

        # sidebar controller
        @controller 'portal::Angular/Ratings/Sidebar/SidebarController',
            ['$scope', '$transitions', 'Ratings.Services.SidebarService', 'Core.Services.Loading', '$q', '$state', '$uibModal']

        # setup tab controller
        @controller 'portal::Angular/Ratings/Sidebar/SetupTabController',
            ['$scope', '$transitions', 'Ratings.Services.SidebarService', '$uibModal', '$state']

        # ratings tab controller
        @controller 'portal::Angular/Ratings/Sidebar/RatingsTabController',
            ['$scope', '$transitions', 'Ratings.Services.SidebarService', '$uibModal', '$state']


        ######################
        # Setup Dialog Stuff #
        ######################

        # setup service
        @service 'portal::Angular/Ratings/Setup/SetupService', ['$http', '$rootScope', 'ratingsFactory']

        # setup dialog controller
        @controller 'portal::Angular/Ratings/Setup/SetupDialogController',
            ['$scope', '$transitions', '$rootScope', 'Ratings.Services.SetupService', 'Core.Services.Loading', '$q', '$state', 'hooks', '$uibModal']

        # trait package dialog controller
        # no defined state - launched from Ratings/Setup/SetupDialogController
        @controller 'portal::Angular/Ratings/Setup/TraitPackageDialogController',
            ['$scope', '$transitions', 'Ratings.Services.SetupService', '$uibModalInstance', 'lineups_id', 'trait_package', 'trait_suppliers']

        # treatment dialog controller
        # no defined state - launched from Ratings/Setup/SetupDialogController
        @controller 'portal::Angular/Ratings/Setup/TreatmentDialogController',
            ['$scope', '$transitions', 'Ratings.Services.SetupService', '$uibModalInstance', 'lineups_id', 'treatment']

        # add/edit product dialog controllers (dialogs are slightly different)
        # no defined states - launched from Ratings/Setup/SetupDialogController
        @controller 'portal::Angular/Ratings/Setup/AddProductDialogController',
            ['$scope', '$transitions', 'Ratings.Services.SetupService', '$uibModalInstance', '$timeout', '$q', 'lineups_id']
        @controller 'portal::Angular/Ratings/Setup/EditProductDialogController',
            ['$scope', '$transitions', 'Ratings.Services.SetupService', '$uibModalInstance', '$timeout', '$q', 'lineups_id', 'product']


        ########################
        # Ratings Dialog stuff #
        ########################

        # ratings service
        @service 'portal::Angular/Ratings/Ratings/RatingsService', ['$http', '$rootScope', 'ratingsFactory']

        # ratings dialog controller
        @controller 'portal::Angular/Ratings/Ratings/RatingsDialogController',
            ['$scope', '$transitions', 'Ratings.Services.RatingsService', 'Core.Services.Loading', '$q', '$state', '$uibModal', '$timeout', '$window']


        ##################
        # Custom Filters #
        ##################

        @filter 'filterInactiveProducts', =>
            return (all_products, show_active_products) =>
                if show_active_products
                    return all_products
                else
                    return _.filter all_products, active: true


    registerRoutes: ($stateProvider) ->
        $stateProvider
            .state 'portal.ratings',
                url: '/ratings'
                templateUrl: 'backend/portal/ratings/sidebar'
                controller: 'Ratings.Controllers.SidebarController'

            .state 'portal.ratings.setup',
                url: '/setup'
                views:
                    'sidebar-tab@portal.ratings':
                        templateUrl: 'backend/portal/ratings/setup-tab'
                        controller: 'Ratings.Controllers.SetupTabController'

            .state 'portal.ratings.setup.dialog',
                url: '/:crop'
                views:
                    'fullpage@portal.ratings':
                        templateUrl: 'backend/portal/ratings/setup/dialog'
                        controller: 'Ratings.Controllers.SetupDialogController'
                resolve:
                    'hooks': => return {}

            .state 'portal.ratings.ratings',
                url: '/ratings'
                views:
                    'sidebar-tab@portal.ratings':
                        templateUrl: 'backend/portal/ratings/ratings-tab'
                        controller: 'Ratings.Controllers.RatingsTabController'

            .state 'portal.ratings.ratings.dialog',
                url: '/:crop'
                views:
                    'fullpage@portal.ratings':
                        templateUrl: 'backend/portal/ratings/ratings/dialog'
                        controller: 'Ratings.Controllers.RatingsDialogController'

            .state 'portal.ratings.ratings.dialog.add_product',
                url: '/add-product'
                views:
                    'fullpage2@portal.ratings.ratings.dialog':
                        templateUrl: 'backend/portal/ratings/setup/dialog'
                        controller: 'Ratings.Controllers.SetupDialogController'
                resolve:
                    'hooks': ['$state', ($state) ->
                        afterLoad: (scope) =>
                            scope.addProduct()
                    ]
